"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cli = cli;
const ora_1 = __importDefault(require("ora"));
const chalk_1 = __importDefault(require("chalk"));
const prompt_1 = __importDefault(require("./prompt"));
/**
 * CLI 交互与日志工具函数
 */
function cli() {
    const spinner = (0, ora_1.default)({
        interval: 70,
    });
    function clean() {
        spinner.stop();
        spinner.text = '';
    }
    return {
        addQuestions: prompt_1.default.addQuestions,
        /**
         * 加载中动画方法集合
         */
        loading: {
            /**
             * 开始加载动画
             * @param text 提示文本
             */
            start(text) {
                clean();
                spinner.start(`${text}\n`);
            },
            /**
             * 显示成功状态
             * @param text 提示文本
             */
            succeed(text) {
                clean();
                spinner.succeed(text);
            },
            /**
             * 显示失败状态
             * @param text 提示文本
             */
            fail(text) {
                clean();
                spinner.fail(text);
            },
            /**
             * 显示警告状态
             * @param text 提示文本
             */
            warn(text) {
                clean();
                spinner.warn(text);
            },
            /**
             * 显示信息状态
             * @param text 提示文本
             */
            info(text) {
                clean();
                spinner.info(text);
            },
            /**
             * 清除加载状态
             */
            clean,
        },
        /**
         * 控制台日志输出方法集合
         */
        log: {
            /**
             * 输出普通信息日志
             * @param msg 消息文本
             * @param datas 附加数据
             */
            info(msg, ...datas) {
                console.log(chalk_1.default.gray.bold(msg, ...datas));
            },
            /**
             * 输出成功日志
             * @param msg 消息文本
             * @param datas 附加数据
             */
            success(msg, ...datas) {
                console.log(chalk_1.default.green.bold(msg, ...datas));
            },
            /**
             * 输出错误日志
             * @param msg 消息文本
             * @param datas 附加数据
             */
            error(msg, ...datas) {
                console.log(chalk_1.default.red.bold(msg, ...datas));
            },
            /**
             * 输出警告日志
             * @param msg 消息文本
             * @param datas 附加数据
             */
            warn(msg, ...datas) {
                console.log(chalk_1.default.hex('#FF8880').bold(msg, ...datas));
            },
            /**
             * 深度打印 JSON 对象
             * @param obj JSON 对象
             */
            printObject(obj) {
                console.dir(obj, { depth: null });
            },
            /**
             * 仅在调试模式下打印。如果使用此方法，需设置 process.env['DEBUG_ENV'] = 'true'
             * @param msg 消息文本
             * @param datas 附加数据
             */
            debug(msg, ...datas) {
                if (process.env['DEBUG_ENV'] === 'true') {
                    console.log(chalk_1.default.blue.bold(msg, ...datas));
                }
            },
        },
    };
}
exports.default = cli;
